// humorUtils.js
export const getHumorLabelAndSummary = (sessions) => {
    const count = sessions.length;
    const courseCount = new Set(sessions.map(s => s.CourseId)).size;
  
    if (count === 0) return {
      label: "🕊️ Freebird",
      summary: "0 classes. You’re free to roam!"
    };
    if (count === 1) return {
      label: "🍵 Breezy",
      summary: "Just 1 class. Chill vibes."
    };
    if (count <= 3) return {
      label: "🌤️ Just Right",
      summary: `${count} sessions across ${courseCount} course${courseCount > 1 ? "s" : ""}.`
    };
    if (count <= 5) return {
      label: "⚡ Zoom Zone",
      summary: `${count} sessions across ${courseCount} courses. Bring snacks.`
    };
    if (count <= 7) return {
      label: "🔥 Zoomageddon",
      summary: `${count} classes today. Can you feel the heat?`
    };
    return {
      label: "🚨 Send Help",
      summary: `${count} sessions—may the Wi-Fi be with you.`
    };
  };
  